export function makeError(message: string, reason: string): Error {
  const error = new Error(message);
  error.name = reason;
  return error;
}
